const r = (a, b) => (b ? (a || 0) / b : null);

export const QUOTA_CATEGORIES = [
  { key: "activations", label: "MTD Activations", kind: "count", source: "Verizon Current Quota", pctBase: "Verizon Current Quota", src: (s) => s.metrics.current_quota },
  { key: "upgrades", label: "MTD Upgrades", kind: "count", source: "Store upgrade goal", pctBase: "Verizon Current Quota", src: (s) => s.goal_upgrades },
  { key: "edge", label: "MTD Edge", kind: "count", pctBase: "Verizon Current Quota" },
  { key: "byod", label: "MTD BYOD", kind: "count", source: "Current Activations", pctBase: "Current Activations", base: (m) => m.current_acts, src: (s) => s.metrics.current_acts },
  { key: "topups", label: "Top-Ups", kind: "count", source: "Prior month Top-Ups", pctBase: "Verizon Current Quota", src: (s) => s.metrics.prior_topups },
  { key: "rewards", label: "Rewards %", kind: "rate", source: "Prior month Rewards %", src: (s) => s.metrics.prior_rewards_pct },
  { key: "zulu", label: "Zulu %", kind: "rate", source: "Prior month Zulu %", src: (s) => r(s.metrics.prior_zulu, s.metrics.prior_zulu_acts) },
  { key: "tablets", label: "Tablets", kind: "count", pctBase: "Verizon Current Quota" },
  { key: "fwa", label: "Home Internet (FWA)", kind: "count", activeOnly: true, pctBase: "Verizon Current Quota" },
  { key: "twp_plus", label: "TWP+ %", kind: "rate" },
  { key: "twp_2mr", label: "TWP 2MR %", kind: "rate" },
  { key: "twp_3mr", label: "TWP 3MR %", kind: "rate" },
  { key: "autopay", label: "AutoPay TA %", kind: "rate" },
  ...[2, 3, 4, 5, 6, 7].map((n) => ({ key: `mr${n}`, label: `Current ${n}MR %`, kind: "rate", source: `Prior month ${n}MR %`,
    src: (s) => r(s.metrics[`prior_mr${n}_pay`], s.metrics[`prior_mr${n}_acts`]) })),
  { key: "lifeline", label: "Lifeline Enrollment", kind: "count", source: "Prior month enrollments", pctBase: "Verizon Current Quota", src: (s) => s.metrics.prior_lifeline },
  { key: "csat", label: "CSAT Score", kind: "rate", source: "Prior month CSAT score", src: (s) => r(s.metrics.prior_csat_promoter, s.metrics.prior_csat_surveys) },
];

const CAT = Object.fromEntries(QUOTA_CATEGORIES.map((c) => [c.key, c]));

const storeTarget = (cat, rule, s) => {
  const m = s.metrics || {};
  if (rule.mode === "source") return cat.src ? cat.src(s) : null;
  if (cat.kind === "rate") return rule.value / 100;
  if (rule.mode === "number") return cat.activeOnly && !m.current_quota ? null : rule.value;
  if (!m.current_quota) return null;
  return (rule.value / 100) * ((cat.base ? cat.base(m) : m.current_quota) || 0);
};

// Quota for a dashboard card across the stores in scope; falls back to the built-in value when every store uses "source".
export const quotaFor = (settings, key, stores, fallback = null) => {
  const cat = CAT[key];
  const base = settings?.[key];
  if (!base || !stores?.length) return fallback;
  const rules = stores.map((s) => base.overrides?.[s.door_tsp] || base);
  if (rules.every((x) => x.mode === "source")) return fallback;
  const vals = stores.map((s, i) => storeTarget(cat, rules[i], s)).filter((v) => v != null);
  if (!vals.length) return null;
  const sum = vals.reduce((a, v) => a + v, 0);
  return cat.kind === "rate" ? sum / vals.length : Math.ceil(sum - 1e-9);
};
